import * as React from "react";
import { useEffect } from "react";
import { useParams } from "react-router";
import { RootState } from "../reducers/index";
import { useAppDispatch, useAppSelector } from "../store/index";
import { setCheckoutState } from "../reducers/checkout";
import { clearCart } from "../reducers/cart";
import { useGetReceiptQuery } from "../reducers/registerapi";
import Loading from "../components/loading";
import ReceiptDisplay from "./receipt/receiptdisplay";

const Receipt = () => {
    const { receiptid } = useParams();
    const { data, isSuccess, error } = useGetReceiptQuery({
        id: receiptid ?? "?",
    }, {});
    const { state } = useAppSelector((state: RootState) => state.checkout);
    const dispatch = useAppDispatch();

    useEffect(() => {
        // Once somebody visits the receipt page then we should clear the cart
        // (assuming we have a valid receipt)
        if (isSuccess && data.isSuccess && state !== "receipt") {
            dispatch(setCheckoutState("receipt"));
            dispatch(clearCart());
        }
    }, [state, dispatch, isSuccess, data]);

    if (error) {
        return (
            <div className="container py-3">
                <div className="alert alert-danger">
                    Sorry, we cannot find your receipt.
                </div>
            </div>
        );
    }

    if (!isSuccess) {
        return (
            <div className="container py-3">
                <Loading />
            </div>
        );
    }

    if (!data.isSuccess) {
        <div className="container py-3">
            <h3>Your Receipt</h3>
            <div className="alert alert-danger">
                {data.errorMessage}
            </div>
        </div>
    }

    return <ReceiptDisplay receipt={data} />;
};

export default Receipt;
